import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA,MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-task-details',
  templateUrl: './task-details.component.html',
  styleUrls: ['./task-details.component.css']
})
export class TaskDetailsComponent implements OnInit {

  formGroups: FormGroup[];
  askQuestionFlag = false;

  constructor(
    public dialogRef: MatDialogRef<TaskDetailsComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private _formBuilder: FormBuilder) {

      if(data.premiumMode){
        this.formGroups = this.data.task.steps.map(() =>
          this._formBuilder.group({
            control: ['', Validators.required]
          })
        );
      }else{
        this.formGroups = this.data.task.services.map(() =>
          this._formBuilder.group({
            control: ['', Validators.required]
          })
        );
      }
    
  }

  ngOnInit(): void {
    
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  askQuestion(): void {
    this.askQuestionFlag = true;
  }

  showNext(i,data){
    if(data.premiumMode){
      return i < data.task.steps.length - 1
    }else{
      return i < data.task.services.length - 1
    }
    
  }
}
